import styled from 'styled-components'

export const StList = styled.ul`
  list-style: disc;
  color: ${({ theme }) => theme.Colors.Neutrals.Darkest};
  padding-left: ${({ theme }) => theme.UI.Spacing.Space6}px;
  margin: 0;

  li {
    display: list-item;
    list-style: inherit;
  }

  li > span {
    display: inline;
  }
`
